export default {
  name: 'fixed',
  directive: {
    inserted(el, binding) {
      const sticker = el.querySelector('.el-table__header-wrapper');

      // 系统默认的 margin 值
      // 理论上应该在 CSS 中初始化掉
      const defaultMargin = 8;
      // CRM 顶部栏高度
      const headerHeight = 80;

      const handler = function() {
        const { top, left, width } = el.getBoundingClientRect();
        if (top - defaultMargin <= 0) {
          sticker.style.position = 'fixed';
          sticker.style.top = `${headerHeight}px`;
          sticker.style.left = `${left}px`;
          sticker.style.zIndex = 200;
          sticker.style.width = `${width}px`;
        } else {
          sticker.style.position = 'static';
        }
      };

      el.__extend__ = { handler };

      window.addEventListener('scroll', handler, true);
    },

    unbind(el, binding) {
      window.removeEventListener('scroll', el.__extend__.handler);
    },
  },
};
